import {Repository, createRepository} from '@/repositories/Base/Repository'

class RecipientRepository extends Repository {
    endpoint = 'integration/monitor'

    listAll(params) {
        return this.$axios.post(`${this.endpoint}/order`, params)
    }

    listOne(params) {
        return this.$axios.post(`${this.endpoint}/automation/recipient`, {
            identifier: params.identifier,
            vns_id: params.vns_id
        })
    }

    listOrders(recipientId) {
        return this.$axios.get(`${this.endpoint}/automation/recipient/${recipientId}/orders`)
    }
    
    listOrdersByVnsId(payload) {
        return this.$axios.get(`${this.endpoint}/automation/recipient/${payload.recipientId}/vns/${payload.vnsId}/orders`)
    }

    listReports(recipientId) {
        return this.$axios.get(`${this.endpoint}/automation/recipient/${recipientId}/reports`)
    }

    listReportsByVnsId(payload) {
        return this.$axios.get(`${this.endpoint}/automation/recipient/${payload.recipientId}/vns/${payload.vnsId}/reports`)
    }

    listOrderExams(orderId) {
        return this.$axios.get(`${this.endpoint}/automation/recipient/order/${orderId}/exams`)
    }

    listReportExams(reportId) {
        return this.$axios.get(`${this.endpoint}/automation/recipient/report/${reportId}/exams`)
    }
}

export default new RecipientRepository()

export const create = createRepository(RecipientRepository)